define([
	"./_List",
	"./PluginFactory"
], function(_List,PluginFactory) {

	return PluginFactory.declare(_List, {
        "class": "csi-button-toggle csi-single-toggle",
		orderType: "ul",
		materialIcon: "format_list_bulleted",
		pluginName: "unorderList",
		title: "CanvasUnorderList"
	});
});
